export const CONSTANTS = {
  HEADING: 'HEADING',
  BODY: 'BODY',
  CHANNEL: 'CHANNEL',
};

export const CHARACTER_LIMIT = {
  HEADING: 38,
  BODY: 100,
  CHANNEL: {
    whatsapp: 20,
    messenger: 20,
    instagram: 20,
  },
};
